import { useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
// css
import styles from "./ClientDetail.module.scss";
import { generatePath, Link, useNavigate, useParams } from "react-router-dom";

// img
import form from "../../../../../Assets/images/form.png";

import { useChatterPeerDetailsQuery, useDeleteReferenceLetterMutation, useGetChatterPeerGroupsListQuery, useGetChatterPeerProgramsListQuery, useLazyGetChatterPeerAttendanceListQuery, useSendReferenceLetterMutation, useUpdateChatterPeerMutation } from "store/services/chatter/peer";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { CHATTER_PEER_EDIT, CHATTER_PEER_LIST, CHATTER_PEER_REFERENCE_LETTER, CHATTER_PEER_REFERENCE_LETTER_V2 } from "config/paths";
import { convertToMomentDate, dateFormat, successMessageToast, userFullName } from "helpers/common";
import moment from "moment";
import { CommonSelect, CommonToolTip, CstmPagination, NoRecordFound } from "components/Common/Common";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { CloseIcon, DeleteIcon, ViewDocumentIcon } from "Assets/icons";
import IconButton from "components/shared/Buttons/IconButton";
import { useFileViewer } from "hooks/useFileViewer";
import { useArchiveChatterPeerMutation } from "store/services/archive";
import ConfirmationPop from "components/Modals/ConfirmationPop";
import NotesComponent from "components/shared/FormComponents/NotesComponent";
import { useGetNoteQuery } from "store/services/note";
import SendIntakePop from "components/Modals/SendIntakeReportPop";
import TableHeader from "components/shared/FormComponents/TableHeader";
import ErrorComponent from "components/shared/ErrorComponent";
import TableLayout from "components/TableLayout";
import { useLazyGetChatterClientAttendanceListQuery } from "store/services/clients/chatter.client";
import AddDocumentPop from "components/Modals/AddDocumentPop";

const ChatterPeerDetail = () => {

  const { id: peerId } = useParams();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1)
  const pageSize = 10
  const [filter, setFilter] = useState({ search: "" })
  const [programId, setProgramId] = useState(null)
  // file viewer hook
  const { handleViewPdf, getFileLoading } = useFileViewer();
  // get peer details
  const { data: peerDetails, isLoading, isFetching, refetch } = useChatterPeerDetailsQuery(peerId, { skip: !peerId });
  const { data: assignedGroups, isLoading: assignedGroupsLoading, isFetching: assignedGroupsFetching, isError: assignedGroupsError } = useGetChatterPeerGroupsListQuery({ ...filter, id: peerId })
  const totalRecords = assignedGroups?.TotalRecords || 0;
  const totalPages = Math.ceil(totalRecords / pageSize);
  const referenceLetters = peerDetails?.clientResources?.length && peerDetails?.clientResources?.filter(item => item.module === `reference_letter`)
  const attachments = peerDetails?.clientResources?.length && peerDetails?.clientResources?.filter(item => item.module !== `reference_letter_${peerId}`)
  let evalutions = peerDetails?.evalutions || [];
  // evalutions = evalutions.filter(item => !!item?.evalution_document);

  // update peer details
  const [updatePeer, { isLoading: updatePeerLoading }] = useUpdateChatterPeerMutation();
  const [sendRererence, { isLoading: sendReferenceLoading }] = useSendReferenceLetterMutation();
  const [deleteReference, { isLoading: deleteReferenceLoading }] = useDeleteReferenceLetterMutation();
  const [archivePeer, { isLoading: archiveLoading }] = useArchiveChatterPeerMutation();
  const [fetchAttendance, { data: attendaceList, isFetching: fetchAttendanceLoading }] = useLazyGetChatterPeerAttendanceListQuery()

  // Notes
  const { data: noteDetails } = useGetNoteQuery({ clientId: peerId, moduleName: "clients-peer" });
  const { data: peerPrograms, isLoading: peerProgramsLoading } = useGetChatterPeerProgramsListQuery({ peerId })

  const [showModal, setShowModal] = useState(false);
  const [showDocumentModal, setShowDocumentModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [currentEntry, setCurrentEntry] = useState(null)
  const [sendReferenceModal, setSendReferenceModal] = useState(false) 


  const uploadDocuments = async (payload) => {
    try {

      setShowDocumentModal(false);

      const values = {
        documents: payload.documents,
        firstname: peerDetails?.firstname,
        lastname: peerDetails?.lastname,
        dob: peerDetails?.client_detail?.dob,
        gender: peerDetails?.client_detail?.gender,
        city_town: peerDetails?.client_detail?.city_town,
        status: peerDetails?.status,
        address: peerDetails?.client_detail?.address,
        phone: peerDetails?.phone,
        email: peerDetails?.email,
        assign_programs: peerDetails?.programDetail?.id
      };

      const result = await updatePeer({ peerId, data: values, });

      if (result?.error) {
        console.error("Error adding document in chatter peer", result.error);
      } else {
        successMessageToast(result?.data?.message);
      }
    } catch (err) {
      console.error("Error adding document in chatter peer", err);
    }
  };

  const handleSendReference = async (values) => {
    try {
      setSendReferenceModal(false);
      const result = await sendRererence({ peerId, refId: currentEntry?.id, email: values?.email });
      if (result?.error) return;
      successMessageToast(result?.data?.message);
      setCurrentEntry(null)
    } catch (err) {
      console.error("Error sending reference", err);
    }
  }

  const handleDeleteReference = async () => {
    try {

      setShowDeleteModal(false);

      const result = await deleteReference({ peerId, referenceId: currentEntry?.id });
      if (!result?.error) successMessageToast("Record has been delete successfully.");
      refetch();

    } catch (err) {
      console.error("error deleting reference", err);
    };
  };

  const handlArchive = async () => {
    try {

      setShowModal(false);

      const result = await archivePeer(peerId);
      if (!result?.error) successMessageToast("Record has been updated successfully.");
      refetch();

    } catch (err) {
      console.error("error archiving peer", err);
    };
  };

  const column = [
    {
      head: "Program Name",
      isComponent: true,
      // sorter: true,
      component: (item, ind) => (
        <h6 className="m-0 fw-bold themeBlue">{item?.name || "--"}</h6>
      ),
    },
    {
      head: "Group Leader 1",
      isComponent: true,
      // sorter: true,
      component: (item, ind) => (
        <h6 className="m-0 fw-bold themeBlue">{userFullName(item?.program_head_one)}</h6>
      ),
    },
    {
      head: "Group Leader 2",
      isComponent: true,
      // sorter: true,
      component: (item, ind) => (
        <h6 className="m-0 fw-bold themeBlue">{userFullName(item?.program_head_two)}</h6>
      ),
    },

  ]

  const resetFilter = () => {
    setFilter({ search: "", appointment_type: "", status: "active" });
    setCurrentPage(1)
  };

  const handleFilterChange = (key) => (value) => {
    setFilter({ ...filter, [key]: value })
    setCurrentPage(1); // Reset to first page when filter changes
  };

  const handlePageChange = (page) => {
    window.scrollTo(0, 0);
    setCurrentPage(page);
  };

  const handleProgram = async (programId) => {
    setProgramId(programId)
    const program = peerPrograms?.programs?.find((item) => item?.program_id == programId?.value)
    console.log('handle program', program)
    try {
      await fetchAttendance({ programId: programId?.value, peerId: program?.id }).unwrap()
    } catch (error) {
      console.log('error fetching attendance: ', error)
    }
  }

  return (
    <>
      <SendIntakePop
        show={sendReferenceModal}
        setShow={setSendReferenceModal}
        submitHandler={handleSendReference}
        heading="Send Reference Letter"
      />
      <ConfirmationPop
        confirmation={showDeleteModal}
        setConfirmation={setShowDeleteModal}
        confirmHandler={handleDeleteReference}
        type="delete"
      />
      <ConfirmationPop
        confirmation={showModal}
        setConfirmation={setShowModal}
        confirmHandler={handlArchive}
        type={peerDetails?.status == "active" ? "archive" : "active"}
      />
      {/* <AddDocumentPop
        show={showDocumentModal}
        setShow={setShowDocumentModal}
        handleSubmit={uploadDocuments}
      /> */}
      <section
        className={`${styles.ClientDetail} position-relative ClientDetail`}
      >
        <Container fluid={true}>
          {
            isLoading ? <LoadingIndicator /> :
              <>
                {(isFetching || getFileLoading || archiveLoading || sendReferenceLoading || deleteReferenceLoading || updatePeerLoading || fetchAttendanceLoading) && <LoadingOverlay />}
                <Row>
                  <Col
                    lg="6"
                    className=""
                    style={{ borderRight: "1px solid #3da0aa4f" }}
                  >
                    <Row>
                      <Col lg="12" className="my-3">
                        <div className="pageHead d-flex align-items-center justify-content-between flex-wrap gap-10">
                          <div className="left">
                            <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center">
                              <li className="">
                                <Link
                                  className="themeBlue fw-sbold back-to-btn"
                                  to={CHATTER_PEER_LIST}
                                >
                                  <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6 12L0 6L6 0L7.425 1.4L2.825 6L7.425 10.6L6 12ZM18 14V10C18 9.16667 17.7083 8.45833 17.125 7.875C16.5417 7.29167 15.8333 7 15 7H8.825L12.425 10.6L11 12L5 6L11 0L12.425 1.4L8.825 5H15C16.3833 5 17.5625 5.4875 18.5375 6.4625C19.5125 7.4375 20 8.61667 20 10V14H18Z" fill="#1C1B1F" />
                                  </svg> Back
                                </Link>
                              </li>
                              <li className="">
                                <Link
                                  className="themeBlue fw-sbold"
                                  style={{ textDecoration: "underline" }}
                                  to={CHATTER_PEER_LIST}
                                >
                                  Chatter Peer
                                </Link>
                              </li>
                              <li className="">
                                <h5 className="m-0 fw-bold themeBlue">/ Details</h5>
                              </li>
                            </ul>
                          </div>
                          <div className="right">
                            <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10">
                              <li className="">
                                <Button
                                  className="d-flex align-items-center rounded-pill justify-content-center btn-sm"
                                  variant="outline-success"
                                  onClick={() => navigate(CHATTER_PEER_EDIT?.replace(":id", peerId))}
                                >
                                  <span className="icn me-1">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="18"
                                      height="18"
                                      viewBox="0 0 18 18"
                                      fill="none"
                                    >
                                      <mask
                                        id="mask0_0_2439"
                                        style={{ maskType: "alpha" }}
                                        maskUnits="userSpaceOnUse"
                                        x="0"
                                        y="0"
                                        width="18"
                                        height="18"
                                      >
                                        <rect width="18" height="18" fill="#D9D9D9" />
                                      </mask>
                                      <g mask="url(#mask0_0_2439)">
                                        <path
                                          d="M1.5 17.9997V15.7497H16.5V17.9997H1.5ZM4.5 12.3099H5.42737L11.6524 6.0963L11.1808 5.61761L10.7136 5.15749L4.5 11.3825V12.3099ZM3.375 13.4349V10.9036L11.7823 2.50792C11.8909 2.3993 12.0142 2.31711 12.1523 2.26136C12.2901 2.20561 12.4336 2.17773 12.5828 2.17773C12.732 2.17773 12.8765 2.20561 13.0163 2.26136C13.156 2.31711 13.2841 2.40317 13.4004 2.51955L14.3019 3.43249C14.4183 3.54111 14.5024 3.66555 14.5543 3.8058C14.6062 3.94592 14.6321 4.0908 14.6321 4.24042C14.6321 4.38067 14.6058 4.52011 14.5532 4.65873C14.5006 4.79748 14.4168 4.9243 14.3019 5.03917L5.90625 13.4349H3.375ZM11.6524 6.0963L11.1808 5.61761L10.7136 5.15749L11.6524 6.0963Z"
                                          fill="currentColor"
                                        />
                                      </g>
                                    </svg>
                                  </span>
                                  Edit
                                </Button>
                              </li>
                              <li className="">
                                <Button
                                  className="d-flex align-items-center rounded-pill justify-content-center btn-sm"
                                  variant="outline-danger"
                                  onClick={() => setShowModal(true)}
                                  disabled={isFetching || archiveLoading}
                                >
                                  {peerDetails?.status == "active" ? <span className="icn me-1">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="12"
                                      height="14"
                                      viewBox="0 0 12 14"
                                      fill="none"
                                    >
                                      <path
                                        d="M2.48081 13.3753C2.10681 13.3753 1.78731 13.2429 1.52231 12.978C1.25744 12.713 1.125 12.3935 1.125 12.0195V2.50029H0.375V1.37529H3.75V0.711914H8.25V1.37529H11.625V2.50029H10.875V12.0195C10.875 12.3984 10.7438 12.719 10.4813 12.9815C10.2188 13.244 9.89806 13.3753 9.51919 13.3753H2.48081ZM9.75 2.50029H2.25V12.0195C2.25 12.0869 2.27162 12.1422 2.31487 12.1854C2.35812 12.2287 2.41344 12.2503 2.48081 12.2503H9.51919C9.57694 12.2503 9.62981 12.2262 9.67781 12.1781C9.72594 12.1301 9.75 12.0772 9.75 12.0195V2.50029ZM4.053 10.7503H5.17781V4.00029H4.053V10.7503ZM6.82219 10.7503H7.947V4.00029H6.82219V10.7503Z"
                                        fill="currentColor"
                                      />
                                    </svg>
                                  </span> : null}
                                  {peerDetails?.status == "active" ? "Archive" : "Active"}
                                </Button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </Col>
                      <Col lg="12" className="my-3">
                        <div className="top d-flex align-items-center gap-10">
                          <div
                            className="igmWrp flex-shrink-0 d-flex themeBlue fw-sbold align-items-center justify-content-center rounded-circle"
                            style={{ height: 35, width: 35, background: "#DBDBDB" }}
                          >
                            {peerDetails?.firstname[0]?.toUpperCase() + peerDetails?.lastname[0]?.toUpperCase()}
                          </div>
                          <div className="content">
                            <h6 className="m-0 themeBlue fw-sbold">{userFullName(peerDetails)}</h6>
                          </div>
                        </div>
                        <Row>
                          <Col md="4" sm="6" className="my-2">
                            <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                              <h6 className="m-0 themeBlue fw-bold">
                                {" "}
                                <span className="" style={{ color: "#3DA0AA" }}>
                                  ■
                                </span>{" "}
                                DOB
                              </h6>
                              <p className="m-0 forteen themeBlue pt-2">{peerDetails?.client_detail?.dob ? moment(peerDetails?.client_detail?.dob).format("DD/MM/YYYY") : "--"}</p>
                            </div>
                          </Col>
                          <Col md="8" className="my-2">
                            <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                              <h6 className="m-0 themeBlue fw-bold">
                                {" "}
                                <span className="" style={{ color: "#3DA0AA" }}>
                                  ■
                                </span>{" "}
                                Address
                              </h6>
                              <p className="m-0 forteen themeBlue pt-2">{peerDetails?.client_detail?.address || "--"}</p>
                            </div>
                          </Col>
                          <Col md="4" sm="6" className="my-2">
                            <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                              <h6 className="m-0 themeBlue fw-bold">
                                {" "}
                                <span className="" style={{ color: "#3DA0AA" }}>
                                  ■
                                </span>{" "}
                                Phone
                              </h6>
                              <p className="m-0 forteen themeBlue pt-2">{peerDetails?.phone || "--"}</p>
                            </div>
                          </Col>
                          <Col md="4" sm="6" className="my-2">
                            <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                              <h6 className="m-0 themeBlue fw-bold">
                                {" "}
                                <span className="" style={{ color: "#3DA0AA" }}>
                                  ■
                                </span>{" "}
                                City/Town
                              </h6>
                              <p className="m-0 forteen themeBlue pt-2">{peerDetails?.client_detail?.city_town || "--"}</p>
                            </div>
                          </Col>
                          {/* {peerDetails?.allPrograms?.length > 0 && (
                            <Col md="6" sm="6" className="my-2">
                              <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                                <h6 className="m-0 themeBlue fw-bold">
                                  {" "}
                                  <span className="" style={{ color: "#3DA0AA" }}>
                                    ■
                                  </span>{" "}
                                  Group Assigned To
                                </h6>
                                <ul className="pt-2">
                                  {peerDetails?.allPrograms.map((program, index) => (
                                    <li key={index}>
                                      <p className="m-0 forteen themeBlue">{program?.name || "--"}</p>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            </Col>
                          )} */}

                          <Col md="4" sm="6" className="my-2">
                            <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                              <h6 className="m-0 themeBlue fw-bold">
                                {" "}
                                <span className="" style={{ color: "#3DA0AA" }}>
                                  ■
                                </span>{" "}
                                Email
                              </h6>
                              <p className="m-0 forteen themeBlue pt-2" style={{ wordWrap: "break-word" }}>{peerDetails?.email || "--"}</p>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                      <Col lg="12" className="my-3">
                        {/* <h6 className="m-0 themeBlue fw-sbold">Notes</h6> */}
                        <NotesComponent
                          notes={noteDetails}
                          className={`${styles.formControl} form-control`}
                          module={"clients-peer"}
                          client_id={peerId}
                        />
                      </Col>
                      <Col lg="12" className="my-3">
                        <div className="TableFilter d-flex align-items-end justify-content-between gap-10  ">
                          <div className="left">
                            <TableHeader
                              heading={"Groups Assigned To:"}
                              hideStatusFilter
                              handleFilterChange={handleFilterChange}
                              resetFilter={resetFilter}
                              filter={filter}
                              searchPlaceholder="Name, Group Leader"
                            >
                            </TableHeader>
                          </div>
                        </div>
                        <div className="table-outer">
                          {assignedGroupsLoading ? (
                            <div style={{ height: "200px" }}>
                              <LoadingIndicator />
                            </div>
                          ) : assignedGroupsError ? <ErrorComponent /> : (
                            <>
                              {(assignedGroupsFetching) && (
                                <LoadingOverlay />
                              )}
                              <TableLayout data={assignedGroups?.Records} column={column} />
                            </>
                          )}
                          <CstmPagination
                            totalPages={totalPages}
                            activePage={currentPage}
                            handlePageChange={handlePageChange}
                          />
                        </div>
                      </Col>
                      <Col lg="12" className="my-2">
                        <h6 class="m-0 themeBlue fw-bold pb-2">Emergency Contact</h6>
                        <div
                          className="cardCstm rounded p-3 shadow"
                          style={{ border: "1px solid rgb(61, 160, 170)" }}
                        >
                          <Row>
                            <Col md="4" sm="6" className="my-2">
                              <h6 class="m-0 themeBlue fw-bold">
                                {" "}
                                <span
                                  class=""
                                  style={{ color: " rgb(61, 160, 170)" }}
                                >
                                  ■
                                </span>{" "}
                                Last Name
                              </h6>
                              <p className="m-0 themeBlue text-capitalize">{peerDetails?.client_detail?.emergency_contact_first_name || "--"}</p>
                            </Col>
                            <Col md="4" sm="6" className="my-2">
                              <h6 class="m-0 forteen themeBlue fw-bold">
                                {" "}
                                <span
                                  class=""
                                  style={{ color: " rgb(61, 160, 170)" }}
                                >
                                  ■
                                </span>{" "}
                                First Name
                              </h6>
                              <p className="m-0 forteen themeBlue text-capitalize">{peerDetails?.client_detail?.emergency_contact_last_name || "--"}</p>
                            </Col>
                            <Col md="4" sm="6" className="my-2">
                              <h6 class="m-0 themeBlue fw-bold">
                                {" "}
                                <span
                                  class=""
                                  style={{ color: " rgb(61, 160, 170)" }}
                                >
                                  ■
                                </span>{" "}
                                Phone
                              </h6>
                              <p className="m-0 forteen themeBlue">{peerDetails?.client_detail?.emergency_contact_phone || "--"}</p>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                      {/* <Col lg="12" className="my-2">
                        <h6 class="m-0 themeBlue fw-bold pb-2">Referring Agency</h6>
                        <div
                          className="cardCstm rounded p-3 shadow"
                          style={{ border: "1px solid rgb(61, 160, 170)" }}
                        >
                          <Row>
                            <Col md="4" sm="6" className="my-2">
                              <h6 class="m-0 themeBlue fw-bold">
                                {" "}
                                <span
                                  class=""
                                  style={{ color: " rgb(61, 160, 170)" }}
                                >
                                  ■
                                </span>{" "}
                                Name
                              </h6>
                              <p className="m-0 themeBlue">{peerDetails?.client_detail?.referring_agency_name || "--"}</p>
                            </Col>
                            <Col md="4" sm="6" className="my-2">
                              <h6 class="m-0 themeBlue fw-bold">
                                {" "}
                                <span
                                  class=""
                                  style={{ color: " rgb(61, 160, 170)" }}
                                >
                                  ■
                                </span>{" "}
                                Phone
                              </h6>
                              <p className="m-0 themeBlue">{peerDetails?.client_detail?.referring_agency_phone || "--"}</p>
                            </Col>
                          </Row>
                        </div>
                      </Col> */}
                    </Row>
                  </Col>
                  <Col lg="6" className="">
                    <Row>
                      <Col lg="12" className="my-2">
                        <div className="d-flex align-items-center justify-content-between flex-wrap gap-10">
                          <h6 className="m-0 themeBlue fw-bold">Reference Letter</h6>
                          <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10">
                            <li className="">
                              <Link
                                to={generatePath(CHATTER_PEER_REFERENCE_LETTER_V2, { chatterId: peerId })}
                                state={{ peer: peerDetails }}
                                className="d-flex btn text-white align-items-center justify-content-center commonBtn"
                              >
                                <span className="icn me-2">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="17"
                                    height="17"
                                    viewBox="0 0 17 17"
                                    fill="none"
                                  >
                                    <path
                                      d="M7.57996 12.2594H9.13993V9.13945H12.2599V7.57947H9.13993V4.45951H7.57996V7.57947H4.46V9.13945H7.57996V12.2594ZM8.35995 16.1593C7.28096 16.1593 6.26698 15.9546 5.31799 15.5451C4.369 15.1356 3.54352 14.5799 2.84153 13.8779C2.13954 13.1759 1.58379 12.3504 1.1743 11.4014C0.764806 10.4524 0.560059 9.43844 0.560059 8.35946C0.560059 7.28047 0.764806 6.26649 1.1743 5.3175C1.58379 4.36851 2.13954 3.54303 2.84153 2.84104C3.54352 2.13905 4.369 1.58331 5.31799 1.17381C6.26698 0.764317 7.28096 0.55957 8.35995 0.55957C9.43893 0.55957 10.4529 0.764317 11.4019 1.17381C12.3509 1.58331 13.1764 2.13905 13.8784 2.84104C14.5804 3.54303 15.1361 4.36851 15.5456 5.3175C15.9551 6.26649 16.1598 7.28047 16.1598 8.35946C16.1598 9.43844 15.9551 10.4524 15.5456 11.4014C15.1361 12.3504 14.5804 13.1759 13.8784 13.8779C13.1764 14.5799 12.3509 15.1356 11.4019 15.5451C10.4529 15.9546 9.43893 16.1593 8.35995 16.1593ZM8.35995 14.5994C10.1019 14.5994 11.5774 13.9949 12.7864 12.7859C13.9954 11.5769 14.5999 10.1014 14.5999 8.35946C14.5999 6.61748 13.9954 5.142 12.7864 3.93302C11.5774 2.72404 10.1019 2.11955 8.35995 2.11955C6.61797 2.11955 5.14249 2.72404 3.93351 3.93302C2.72453 5.142 2.12004 6.61748 2.12004 8.35946C2.12004 10.1014 2.72453 11.5769 3.93351 12.7859C5.14249 13.9949 6.61797 14.5994 8.35995 14.5994Z"
                                      fill="white"
                                    />
                                  </svg>
                                </span>{" "}
                                Create Reference Letter
                              </Link>
                            </li>
                          </ul>
                        </div>
                        {referenceLetters?.length > 0 ? (
                          <Row>
                            {referenceLetters?.map((letter, index) => {
                              return (
                                <Col key={index} lg="3" md="4" sm="6" className="my-2">
                                  <div className="cardCstm rounded bg-white shadow position-relative">
                                    <img
                                      src={form}
                                      alt=""
                                      className="img-fluid object-fit-contain rounded"
                                    />
                                    <div
                                      className="content position-absolute h-100 w-100 d-flex align-items-center justify-content-center flex-column gap-10 px-4"
                                      style={{ top: 0, left: -0 }}
                                    >
                                      <CloseIcon
                                        style={{ top: "6px", right: "6px", opacity: "0.5", height: "8px", width: "8px", cursor: "pointer" }}
                                        className="position-absolute"
                                        onClick={() => {
                                          setCurrentEntry(letter);
                                          setShowDeleteModal(true);
                                        }}
                                      />
                                      <IconButton
                                        onClick={() => {
                                          handleViewPdf(letter?.attachment_name);
                                        }}
                                      >
                                        <span className="icn">
                                          <ViewDocumentIcon />
                                        </span>
                                      </IconButton>
                                      <Button
                                        style={{ minWidth: "unset" }}
                                        className="d-flex align-items-center justify-content-center commonBtn  w-100 h-auto"
                                        onClick={() => {
                                          setSendReferenceModal(true);
                                          setCurrentEntry(letter)
                                        }}
                                      >
                                        Send
                                      </Button>
                                    </div>
                                  </div>
                                </Col>
                              )
                            })}
                          </Row>
                        ) : (
                          <NoRecordFound />
                        )}
                      </Col>

                      <AddDocumentPop
                        show={showDocumentModal}
                        setShow={setShowDocumentModal}
                        handleSubmit={(values) => {
                          setShowDocumentModal(false)
                          uploadDocuments(values);
                        }}
                      />

                      <Row>
                        <Col lg="12" className="my-2">
                          <div className="d-flex justify-content-between">
                            <h5 className="m-0 themeBlue fw-bold pb-2">Attachments:</h5>
                            <Button
                              className="d-flex align-items-center justify-content-center commonBtn borderedBtn bg-transparent"
                              onClick={() => setShowDocumentModal(true)}
                            >
                              Add Attachment
                            </Button>
                          </div>
                          <div
                            style={{ maxHeight: "300px", overflowY: "auto" }}
                            className={`tableResponsive table-responsive mb-3 pb-0`}
                          >
                            {!attachments?.length ? <NoRecordFound /> : <table className={`table mb-0`}>
                              <thead className="sticky">
                                <tr>
                                  <th className="m-0 themeBlue fw-bold p-1 bg-transparent">Document</th>
                                  <th className="m-0 themeBlue fw-bold p-1 bg-transparent">Date</th>
                                  <th className="m-0 themeBlue fw-bold p-1 bg-transparent"></th>
                                </tr>
                              </thead>
                              <tbody>
                                {
                                  attachments?.map((item, index) => {
                                    return (
                                      <tr key={index}>
                                        <td style={{ width: "80%" }} className="">
                                          <div className="d-flex align-items-center gap-10">
                                            <span className="icn flex-shrink-0">
                                              {/* <img
                                                src={formIcn}
                                                alt=""
                                                className="img-fluid"
                                              /> */}
                                            </span>
                                            <CommonToolTip
                                              text={item?.attachment_name}
                                              component={
                                                <p style={{ maxWidth: "250px", textOverflow: "ellipsis", overflow: "hidden" }} className="m-0 p-0" role="button" onClick={() => handleViewPdf(item?.attachment_key)}>{item?.attachment_name || "--"}</p>
                                              }
                                            />
                                          </div>
                                        </td>
                                        <td className="">{dateFormat(item?.createdAt)}</td>
                                        <td className="">
                                          <div className="d-flex align-items-center gap-10">
                                            <div style={{ backgroundColor: "#ebffeb", padding: "6px", borderRadius: "100px" }}>
                                              <CommonToolTip
                                                text={"View"}
                                                component={
                                                  <ViewDocumentIcon
                                                    style={{ width: "15px", height: "15px" }}
                                                    onClick={() => handleViewPdf(item?.attachment_key)}
                                                    className="cursor-pointer"

                                                  />}
                                              />
                                            </div>
                                            <div style={{ backgroundColor: "#ebffeb", padding: "6px", borderRadius: "100px" }}>
                                              <CommonToolTip
                                                text={"Delete"}
                                                component={
                                                  <DeleteIcon
                                                    className="cursor-pointer"
                                                    onClick={() => {
                                                      setCurrentEntry(item);
                                                      setShowDeleteModal(true);
                                                    }}
                                                  />
                                                }
                                              />
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                    )
                                  })
                                }
                              </tbody>
                            </table>}
                          </div>
                        </Col>
                      </Row>

                      <Row>
                        <Col lg="12" className="my-2">
                          <div className="my-2">
                            <h6 className="m-0 themeBlue fw-bold my-3">Evaluations:</h6>
                          </div>
                          <div
                            style={{ maxHeight: "300px", overflowY: "auto" }}
                            className={`tableResponsive table-responsive  pb-0`}
                          >
                            {!evalutions?.length ? <NoRecordFound /> : <table className={`table mb-0`}>
                              <thead className="sticky">
                                <tr>
                                  <th className="m-0 themeBlue fw-bold p-1 bg-transparent">Session Date</th>
                                  <th className="m-0 themeBlue fw-bold p-1 bg-transparent">Created At</th>
                                  <th className="m-0 themeBlue fw-bold p-1 bg-transparent"></th>
                                </tr>
                              </thead>
                              <tbody>
                                {
                                  evalutions?.map((item, index) => {
                                    return (
                                      <tr key={index}>
                                        <td className="">
                                          {item?.session_date}
                                        </td>
                                        <td className="">{convertToMomentDate(item?.createdAt)}</td>
                                        <td className="">
                                          {item?.evalution_document && (
                                            <div className="d-flex align-items-center gap-10">
                                              <div style={{ backgroundColor: "#ebffeb", padding: "6px", borderRadius: "100px" }}>
                                                <CommonToolTip
                                                  text={"View"}
                                                  component={
                                                    <ViewDocumentIcon
                                                      style={{ width: "15px", height: "15px" }}
                                                      className="cursor-pointer"
                                                      onClick={() => handleViewPdf(item?.evalution_document)}
                                                    />
                                                  }
                                                />
                                              </div>
                                            </div>
                                          )}
                                        </td>
                                      </tr>
                                    )
                                  })
                                }
                              </tbody>
                            </table>}
                          </div>
                        </Col>
                      </Row>

                      <Row>
                        <Col lg="12" className="my-2">
                          <div className="d-flex align-items-center justify-content-between flex-wrap gap-10">
                            <h6 className="m-0 themeBlue fw-sbold">Track Attendence</h6>
                            <div className="w-100">
                              {/* <label
                                                     htmlFor=""
                                                     className="form-label themeBlue fw-bold mb-0 d-flex"
                                                   >
                                                     Select Program
                                                   </label> */}
                              <CommonSelect
                                option={peerPrograms?.programs?.length > 0 ? peerPrograms?.programs?.map((item) => ({ label: item?.programMembers?.name, value: item?.program_id })) : []}
                                onChange={(e) => handleProgram(e)}
                                value={programId}
                                isLoading={peerProgramsLoading}
                              />
                            </div>
                          </div>
                        </Col>
                        <Col lg="12" className="my-2">
                          {/* <p className="m-0 d-flex align-items-center fw-sbold py-2">Event Date</p> */}
                          <div className={`${styles.tableResponsive} tableResponsive table-responsive border rounded-2 mb-3 pb-0`}>
                            <table className={`${styles.table} table mb-0`}>
                              <thead>
                                <tr>
                                  <th className="text-dark fw-bold bg-transparent">Event Date</th>
                                  <th className="text-dark fw-bold bg-transparent">PRESENT</th>
                                  {/* {data?.memberDetails?.client_detail?.client_type === "chatter" && client?.location_type == "community" && (
                                                          <th className="text-dark fw-bold bg-transparent">PARENT</th>
                                                        )} */}
                                </tr>
                              </thead>
                              <tbody>
                                {!programId?.value ? <tr><td colSpan={2} className="border-0 p-2 text-center">Please Select a Program</td></tr> : attendaceList?.lessonDates?.length ? attendaceList?.lessonDates?.map((item, index) => (
                                  <tr key={`${index}-${index}`}>
                                    <td className="border-0 p-2 text-capitalize">
                                      {convertToMomentDate(item?.session_date) || "--"}
                                    </td>
                                    <td className="border-0 p-2">
                                      <span>
                                        {item?.attendance?.[0]?.attendance === "present" ? <PresentIcon /> : <AbsentIcon />}
                                      </span>
                                    </td>
                                    {/* {data?.memberDetails?.client_detail?.client_type === "chatter" && client?.location_type == "community" && (
                                                            <td className="border-0 p-2">
                                                              <span>
                                                                {userAttendance?.with_parent === "yes" ? <PresentIcon /> : <AbsentIcon />}
                                                              </span>
                                                            </td>
                                                          )} */}
                                  </tr>
                                )) : <tr><td colSpan={2} className="border-0 p-2 text-center">No Record Found</td></tr>
                                }
                              </tbody>
                            </table>
                          </div>
                        </Col>
                      </Row>
                      {/* <Col lg="12" className="my-2">
                        <div className="w-100 d-flex justify-content-between">
                          <h5 className="m-0 themeBlue fw-bold pb-2">Attachments:</h5>

                          <Button
                            className="d-flex align-items-center justify-content-center commonBtn borderedBtn bg-transparent"
                            onClick={() => setShowDocumentModal(true)}
                          >

                            Add Attachment
                          </Button>
                        </div>
                        <div
                          className={`${styles.tableResponsive} tableResponsive table-responsive mb-3 pb-0`}
                        >
                          <table className={`${styles.table} table mb-0`}>
                            <tbody>
                              {
                                !attachments?.length ? <NoRecordFound /> : attachments?.map((item, index) => {
                                  return (
                                    <tr key={index}>
                                      <td className="">
                                        <div className="d-flex align-items-center gap-10">
                                          <span className="icn flex-shrink-0">
                                            <img
                                              src={formIcn}
                                              alt=""
                                              className="img-fluid"
                                            />
                                          </span>
                                          <p className="m-0">{item?.attachment_name || "--"}</p>
                                        </div>
                                      </td>
                                      <td className=""></td>
                                      <td className=""></td>
                                      <td className="">
                                        <div className="d-flex gap-10">
                                          <Button
                                            style={{ minWidth: "unset " }}
                                            className="d-flex align-items-center justify-content-center commonBtn h-auto"
                                            onClick={() => {
                                              handleViewPdf(item?.attachment_name);
                                            }}
                                          >
                                            <span className="icn me-1">
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="16"
                                                height="11"
                                                viewBox="0 0 16 11"
                                                fill="none"
                                              >
                                                <path
                                                  d="M8.00162 8.68275C8.8515 8.68275 9.57331 8.38531 10.1671 7.79044C10.7608 7.19556 11.0577 6.47319 11.0577 5.62331C11.0577 4.77344 10.7602 4.05163 10.1654 3.45787C9.5705 2.86412 8.84812 2.56725 7.99825 2.56725C7.14837 2.56725 6.42656 2.86469 5.83281 3.45956C5.23906 4.05444 4.94218 4.77681 4.94218 5.62669C4.94218 6.47656 5.23962 7.19837 5.8345 7.79212C6.42937 8.38587 7.15175 8.68275 8.00162 8.68275ZM7.99993 7.65C7.43743 7.65 6.95931 7.45313 6.56556 7.05938C6.17181 6.66563 5.97493 6.1875 5.97493 5.625C5.97493 5.0625 6.17181 4.58437 6.56556 4.19063C6.95931 3.79688 7.43743 3.6 7.99993 3.6C8.56243 3.6 9.04056 3.79688 9.43431 4.19063C9.82806 4.58437 10.0249 5.0625 10.0249 5.625C10.0249 6.1875 9.82806 6.66563 9.43431 7.05938C9.04056 7.45313 8.56243 7.65 7.99993 7.65ZM8.00087 10.875C6.27625 10.875 4.70481 10.3993 3.28656 9.44775C1.86831 8.49638 0.824059 7.22213 0.153809 5.625C0.824059 4.02787 1.86793 2.75362 3.28543 1.80225C4.70306 0.85075 6.27425 0.375 7.999 0.375C9.72362 0.375 11.2951 0.85075 12.7133 1.80225C14.1316 2.75362 15.1758 4.02787 15.8461 5.625C15.1758 7.22213 14.1319 8.49638 12.7144 9.44775C11.2968 10.3993 9.72562 10.875 8.00087 10.875ZM7.99993 9.75C9.41243 9.75 10.7093 9.37813 11.8906 8.63437C13.0718 7.89062 13.9749 6.8875 14.5999 5.625C13.9749 4.3625 13.0718 3.35938 11.8906 2.61562C10.7093 1.87187 9.41243 1.5 7.99993 1.5C6.58743 1.5 5.29056 1.87187 4.10931 2.61562C2.92806 3.35938 2.02493 4.3625 1.39993 5.625C2.02493 6.8875 2.92806 7.89062 4.10931 8.63437C5.29056 9.37813 6.58743 9.75 7.99993 9.75Z"
                                                  fill="white"
                                                />
                                              </svg>
                                            </span>
                                            View
                                          </Button>
                                        </div>
                                      </td>
                                    </tr>
                                  )
                                })
                              }

                            </tbody>
                          </table>
                        </div>
                      </Col> */}
                    </Row>
                  </Col>
                </Row>
              </>
          }
        </Container>
      </section>
    </>
  );
};

export default ChatterPeerDetail;


const PresentIcon = () => {
  return (<svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M8.6 14.6L15.65 7.55L14.25 6.15L8.6 11.8L5.75 8.95L4.35 10.35L8.6 14.6ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20Z"
      fill="#16BF12"
    />
  </svg>)
}

const AbsentIcon = () => {
  return (
    <svg
      width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_5342_36802" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5342_36802)">
        <path d="M12 21C10.7468 21 9.58226 20.763 8.49619 20.2943C7.39072 19.8173 6.43908 19.1749 5.63211 18.3679C4.82514 17.5609 4.18269 16.6093 3.70567 15.5038C3.23702 14.4177 3 13.2532 3 12C3 10.7468 3.23702 9.58226 3.70567 8.49619C4.18269 7.39072 4.82514 6.43908 5.63211 5.63211C6.43908 4.82514 7.39072 4.18269 8.49619 3.70567C9.58226 3.23702 10.7468 3 12 3C13.2532 3 14.4177 3.23702 15.5038 3.70567C16.6093 4.18269 17.5609 4.82514 18.3679 5.63211C19.1749 6.43908 19.8173 7.39072 20.2943 8.49619C20.763 9.58226 21 10.7468 21 12C21 13.2532 20.763 14.4177 20.2943 15.5038C19.8173 16.6093 19.1749 17.5609 18.3679 18.3679C17.5609 19.1749 16.6093 19.8173 15.5038 20.2943C14.4177 20.763 13.2532 21 12 21Z" fill="#ECECEC" stroke="#16BF12" stroke-width="2" />
      </g>
    </svg>
  )
}